import { render, staticRenderFns } from "./NbModal.vue?vue&type=template&id=e9517154&scoped=true&"
import script from "./NbModal.vue?vue&type=script&lang=js&"
export * from "./NbModal.vue?vue&type=script&lang=js&"
import style0 from "./NbModal.vue?vue&type=style&index=0&id=e9517154&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9517154",
  null
  
)

export default component.exports